var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bio-detail" },
    [
      _vm.data.nav["back-link"]
        ? _c(
            "z-link",
            {
              staticClass: "bio-detail__back-link",
              attrs: {
                size: "m",
                iconPosition: "left",
                icon: "arrow",
                href: _vm.data.nav["back-link"],
              },
            },
            [_vm._v(_vm._s(_vm.text.linkText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "bio-detail__head" }, [
        _vm.data.detailPicture && _vm.data.detailPicture.link
          ? _c("div", {
              staticClass: "bio-detail__image",
              style:
                "background-image: url(" + _vm.data.detailPicture.link + ")",
            })
          : _c("div", {
              staticClass: "bio-detail__image",
              staticStyle: {
                "background-image": "url(/images/biographies/imageholder.svg)",
              },
            }),
        _vm._v(" "),
        _c("div", { staticClass: "bio-detail__person" }, [
          _c("div", {
            staticClass: "bio-detail__name",
            domProps: { innerHTML: _vm._s(_vm.data.name) },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "bio-detail__post",
            domProps: { innerHTML: _vm._s(_vm.data.position.value) },
          }),
          _vm._v(" "),
          _vm.data.committee
            ? _c(
                "div",
                { staticClass: "bio-detail__committee" },
                _vm._l(_vm.data.committee, function (committee, i) {
                  return _c(
                    "div",
                    {
                      key: committee.code,
                      staticClass: "bio-detail__committee-el",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "bio-detail__committee-letter",
                          style: {
                            "background-color": _vm.colorsEnum[i],
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.getFirstLetterCommittee(committee.name))
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(committee.name) },
                      }),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bio-detail__content" }, [
        _vm.data.previewText
          ? _c("div", { staticClass: "bio-detail__detail" }, [
              _c("div", {
                staticClass: "bio-detail__position-description",
                domProps: { innerHTML: _vm._s(_vm.data.previewText) },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.data.destination.value
          ? _c(
              "div",
              { staticClass: "bio-detail__position" },
              [
                _c("div", {
                  staticClass: "bio-detail__position-title",
                  domProps: { innerHTML: _vm._s(_vm.text.destination) },
                }),
                _vm._v(" "),
                _c("vue-raw", {
                  staticClass: "html-content bio-detail__position-description",
                  domProps: { innerHTML: _vm._s(_vm.data.destination.value) },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.experience.value
          ? _c(
              "div",
              { staticClass: "bio-detail__experience" },
              [
                _c("div", {
                  staticClass: "bio-detail__experience-title",
                  domProps: { innerHTML: _vm._s(_vm.text.experience) },
                }),
                _vm._v(" "),
                _c("vue-raw", {
                  staticClass:
                    "html-content bio-detail__experience-description",
                  domProps: { innerHTML: _vm._s(_vm.data.experience.value) },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.data.education.value
          ? _c(
              "div",
              { staticClass: "bio-detail__education" },
              [
                _c("div", {
                  staticClass: "bio-detail__education-title",
                  domProps: { innerHTML: _vm._s(_vm.text.education) },
                }),
                _vm._v(" "),
                _c("vue-raw", {
                  staticClass: "html-content bio-detail__education-description",
                  domProps: { innerHTML: _vm._s(_vm.data.education.value) },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.data.nav.prev || _vm.data.nav.next
        ? _c("page-changer", {
            staticClass: "bio-detail__footer u-top-margin--l",
            attrs: {
              data: {
                next: {
                  name: _vm.data.nav.next ? _vm.data.nav.next.name : "",
                  url: _vm.data.nav.next ? _vm.data.nav.next.url : "",
                },
                prev: {
                  name: _vm.data.nav.prev ? _vm.data.nav.prev.name : "",
                  url: _vm.data.nav.prev ? _vm.data.nav.prev.url : "",
                },
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }